import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { ISession } from '../../models/session';
import { ICalendarContent } from '../../models/calendarContent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class IcsService extends BasicService {
  private API = config.emailsv3.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
  ) {
    super(authService, translate);
  }

  public getCalendarContent(session: ISession, notify: boolean = false): Observable<ICalendarContent> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/calendar_content`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public saveCalendarContent(session: ISession, content: ICalendarContent, notify: boolean = true): Observable<ICalendarContent> {
    return this.http
      .put(`${this.API}/sessions/${session.id}/calendar_content`, content)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/ics.service.ts